import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'

function SocialButtons({ showSeparator }) {
    return (
        <section className="p-3">
            <div className="container text-center">
                <div className="row d-flex justify-content-between w-75 mx-auto">
                    <div className="col-md-6 mx-auto">
                        <a
                            href="https://www.facebook.com/Elias-Gomes-Autom%C3%B3veis-2017862641798863/"
                            className="btn btn-fb facebookButton"
                            role="button"
                            target="_blank"
                        >
                            <FontAwesomeIcon icon={faFacebookF} fixedWidth className="pr-2"/>
                            Facebook
                        </a>
                    </div>
                    <div className="col-md-6 mx-auto">
                        <a
                            href="https://www.instagram.com/elias_gomes_automoveis/"
                            className="btn btn-fb instragamButton"
                            role="button"
                            target="_blank"
                        >
                            <FontAwesomeIcon icon={faInstagram} fixedWidth className="pr-2"/>
                            Instagram
                        </a>
                    </div>
                    {showSeparator && <div className="separator mx-auto" />}
                </div>
            </div>
        </section>
    );
}

export default SocialButtons;
